import Dialog from '@material-ui/core/Dialog';

/** @deprecated Exporting the Dialog component from the @material-ui/core/Dialog module. */
export default Dialog;
